import { toMobileFontSize } from '../font-utils/to-mobile-font-size';
import { getMobileFontSizeClassName } from './get-mobile-font-size-class-name';
import { extractValuesFromHtml } from './html';
const fontSizeExtractor = ($) => ['span', 'ul', 'li', 'p', 'h1', 'h2', 'h3', 'div']
    .map((e) => {
    return $(e)
        .map((_id, el) => $(el).css('font-size'))
        .get()
        .map(toMobileFontSize);
})
    .reduce((acc, curr) => acc.concat(curr), []);
export const getMobileFontSizeClasses = (htmls, _props) => extractValuesFromHtml(htmls, fontSizeExtractor)
    .map((fontSize) => `.${getMobileFontSizeClassName(fontSize)}{font-size: ${fontSize}px !important;}`)
    .join(' ');
//# sourceMappingURL=get-mobile-font-size-classes.js.map